/* globals Routes */

angular
  .module('services.RoutesService', [])
  .service('RoutesService', [
    function() {
      return Routes;
    }
  ]);
